export { default as jQuery, default as $ } from "jquery";
